import { render } from "./quit.vue?vue&type=template&id=163b664e&ts=true"
import script from "./quit.vue?vue&type=script&lang=ts"
export * from "./quit.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/quit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "163b664e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('163b664e', __exports__)) {
    api.reload('163b664e', __exports__)
  }
  
  module.hot.accept("./quit.vue?vue&type=template&id=163b664e&ts=true", () => {
    api.rerender('163b664e', render)
  })

}


export default __exports__